import React from 'react';
import { Button, Container, Grid, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Main() {
  const navigate = useNavigate();

  return (
    <Container>
      <Button
        sx={{
          mb: 2,
          color: 'primary.main',
          '&:hover': { bgcolor: 'grey.200' },
        }}
        variant="text"
        onClick={() => {
          navigate('/admin');
        }}
      >
        <span>← Back to Overview</span>
      </Button>

      <div className="help__center__container" lang="en">
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item>
              <Button variant="outlined" href="/help-center/dashboard">
                Overview
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/building">
                Building
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/devices">
                Devices
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/settings">
                Settings
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/map">
                Map
              </Button>
            </Grid>
          </Grid>
        </Box>
        <div className="help__center__hero">
          <h1>Support - Sastech Dashboard</h1>
        </div>
        <div>
          <h2>Frequently Asked Questions</h2>
          <h3>How do I get started?</h3>
          <p>
            To get started, simply log in to your Sastech Dashboard account. If
            you do not have an account yet, please contact our support or sales
            team for assistance. Once logged in, you can access various features
            and tools to manage your Energy Management System.
          </p>
          <h3>How do I reset my password?</h3>
          <p>
            If you have forgotten your password, click on the Forgot Password?
            link on the login page. Follow the instructions to reset your
            password via email. If you encounter any issues, please contact our
            support team for assistance.
          </p>
          <h3>How do I contact support?</h3>
          <p>
            You can either send an email to our support team at{' '}
            <a href="mailto:support@sastech.no">support@sastech.no</a> or, when
            logged in, use Feedback in the dashboard menu. Our support team is
            available Monday to Friday, 8 AM to 4 PM (Europe/Oslo). We strive to
            respond to all inquiries within 12 hours on business days.
          </p>
          <h3>Dashboard Visual Guide</h3>
          <p>
            Want to understand each section of the dashboard?{' '}
            <a href="/help-center/dashboard">EOS Dashboard Guide</a>
          </p>
        </div>
      </div>
    </Container>
  );
}
